import apiClient from '../../../core/api/client';

export const getDashboardStats = async () => {
  const response = await apiClient.get('/api/reports/dashboard-stats');
  return response.data;
};

export const downloadAccountantExport = async (year, month) => {
    const response = await apiClient.get('/api/reports/accountant-export', {
        params: { year, month },
        responseType: 'blob',
    });
    const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `muhasebe_raporu_${year}_${String(month).padStart(2, '0')}.xlsx`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
